import React from 'react';

/**
 * Spinner con efecto meteoro — conic-gradient de transparente a naranja,
 * enmascarado para dejar solo el anillo, creando una cola de cometa al girar.
 */
const Spinner = ({ size = 64, className = '' }) => {
  const thickness = Math.max(3, Math.round(size / 10));
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'conic-gradient(from 0deg, rgba(255,107,0,0) 0%, rgba(255,107,0,0.25) 40%, #FF6B00 80%, #FF8C00 100%)',
        WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #fff calc(100% - ${thickness - 1}px))`,
        mask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #fff calc(100% - ${thickness - 1}px))`,
        animation: 'spin 0.75s linear infinite',
        filter: 'drop-shadow(0 0 6px rgba(255,107,0,0.6))',
      }}
    />
  );
};

export default Spinner;
